import {
  collection,
  CollectionReference,
  QueryDocumentSnapshot,
  Timestamp,
} from "firebase/firestore";

import { db } from "integrations/firebase/firestore";
import { FirestoreOrganisation } from "reedy-data/models";
import {
  FirestoreOrganisationLanguage,
  FirestoreOrganisationMarketplace,
  FirestoreOrganisationSettings,
} from "reedy-data/api";

export function getEffectiveLanguage(
  settings: FirestoreOrganisationSettings = {},
) {
  if (settings.language) {
    return settings.language;
  }

  switch (settings.marketplace) {
    case FirestoreOrganisationMarketplace.UK:
      return FirestoreOrganisationLanguage.EN_GB;
    case FirestoreOrganisationMarketplace.US:
      return FirestoreOrganisationLanguage.EN_US;
    case FirestoreOrganisationMarketplace.GER:
      return FirestoreOrganisationLanguage.DE_DE;
    case FirestoreOrganisationMarketplace.AU:
      return FirestoreOrganisationLanguage.EN_GB;
    default:
      return FirestoreOrganisationLanguage.EN_US;
  }
}

interface FirestoreOrganisationFromFirebase
  extends Omit<FirestoreOrganisation, "deletedAt" | "hardDeletedAt"> {
  deletedAt?: Timestamp;
  hardDeletedAt?: Timestamp;
}

export interface Organisation extends FirestoreOrganisation {
  effectiveLanguage: FirestoreOrganisationLanguage;
}

const organisationConverter = {
  toFirestore(organisation: Organisation) {
    // biome-ignore lint/correctness/noUnusedVariables: drops the derived effectiveLanguage before the document is written to Firestore
    const { effectiveLanguage, ...rest } = organisation;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot<FirestoreOrganisationFromFirebase>,
  ): Organisation {
    const organisation = snapshot.data();
    return {
      ...organisation,
      deletedAt: organisation.deletedAt?.toDate(),
      hardDeletedAt: organisation.hardDeletedAt?.toDate(),
      effectiveLanguage: getEffectiveLanguage(organisation.settings),
    };
  },
};

export const getOrganisationsCollection =
  (): CollectionReference<Organisation> =>
    collection(db, "organisations").withConverter(organisationConverter);
